import { Box, Step, Stepper, StepLabel } from '@mui/material';

const steps = [
  '画像のアップロード',
  '見積発行 & 返送先登録',
  'お支払い',
  '注文完了',
];

type Props = {
  step: number;
};

export default function OrderProgressStepper(props: Props) {
  return (
    <Box sx={{ width: '100%' }}>
      <Stepper activeStep={props.step - 1} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}
